export const classRoutineApi = {
    heading:[
        
        {
            head:"Class"
        },
        {
            head:"Section"
        },
        {
            head:"Day"
        },
        {
            head:"1st"
        },
        {
            head:"2nd"
        },
        {
            head:"3rd"
        },
        {
            head:"4th"
        },
        {
            head:"5th"
        },
        {
            head:"6th"
        },
        {
            head:"7th"
        },
    ],
    data:[
       {
            class:"Class 4",
            section:"Diamond 1",
            day:"Monday",
            first:"English",
            second:"Mathematics",
            third:"ICT",
            fourth:"Bengali",
            fifth:"Art & Craft",
            sixth:"Sociology",
            seventh:"Science"
       },
       {
            class:"Class 6",
            section:"Diamond 1",
            day:"Monday",
            first:"English",
            second:"Mathematics",
            third:"ICT",
            fourth:"Bengali",
            fifth:"Art & Craft",
            sixth:"Sociology",
            seventh:"Science"
       },
    
      
     
   
       
    ]
}